import { z } from 'zod';
export const numberingPattern = z.string().trim().min(1).max(55).refine(value => {
  const sequence = value.match(/\{#{3,8}\}/g);
  return sequence?.length === 1 && /^[A-Za-z0-9 /_.-]*$/.test(value.replace(/\{(?:#{3,8}|FY|ENTITY)\}/g, ''));
}, 'Use one sequence token, such as {####}, with optional {FY} and {ENTITY}.');
export function formatDocumentNumber(pattern: string, sequence: number, fiscalStart: string, entityPrefix: string) {
  return numberingPattern.parse(pattern).replace(/\{FY\}/g, fiscalStart.slice(2, 4)).replace(/\{ENTITY\}/g, entityPrefix.replace(/[^A-Za-z0-9_-]/g, '').slice(0,20) || 'CO')
    .replace(/\{(#{3,8})\}/, (_, hashes: string) => String(sequence).padStart(hashes.length, '0'));
}
